import styled from 'styled-components/macro';
import { deviceMin } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const StyledSectionWrapper = styled.div`
  .pagination {
    .MuiPagination-root {
      width: 100%;
      ${FLEX_CONTAINER.FlexRow}

      li {
        button {
          border: 1px solid ${COLORS.mainColor};
          border-radius: 10px;
          color: ${COLORS.mainColor};
        }
      }

      @media ${deviceMin.mobileS} {
        margin-top: 40px;
      }

      @media ${deviceMin.tablet} {
        margin-top: 75px;
      }

      @media ${deviceMin.laptopL} {
        margin-top: 80px;
      }

      @media ${deviceMin.desktop} {
        margin-top: 90px;
      }
    }
  }

  .styledSectionWrapper {
    background: ${COLORS.white};
    height: 100%;

    @media ${deviceMin.mobileS} {
      padding: 100px 40px;
      ${FLEX_CONTAINER.FlexRow}
    }

    @media ${deviceMin.tablet} {
      padding: 105px 80px;
      justify-content: flex-start;
    }

    @media ${deviceMin.laptopL} {
      padding: 105px 134px;
    }

    @media ${deviceMin.desktop} {
      padding: 105px 286px;
    }
  }

  .titleIcon {
    ${FLEX_CONTAINER.FlexRow}

    @media ${deviceMin.mobileS} {
      margin-bottom: 14px;
    }

    @media ${deviceMin.tablet} {
      margin-bottom: 25px;
    }

    @media ${deviceMin.laptopL} {
      margin-bottom: 32px;
    }

    @media ${deviceMin.desktop} {
      margin-bottom: 50px;
    }
  }

  img {
    @media ${deviceMin.mobileS} {
      width: 48px;
      height: 47px;
      margin-left: 16px;
    }

    @media ${deviceMin.tablet} {
      width: 48px;
      height: 47px;
      margin-left: 16px;
    }

    @media ${deviceMin.laptopL} {
      width: 69px;
      height: 67px;
      margin-left: 21px;
    }

    @media ${deviceMin.desktop} {
      width: 96px;
      height: 93px;
      margin-left: 40px;
    }
  }

  p {
    ${FONT_FAMILY.FontBold}
    ${FONTS.font24}
    color: ${COLORS.mainColor};

    @media ${deviceMin.mobileS} {
      ${FONTS.font16}
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font16}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font20}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font24}
    }
  }
`;
